import { render } from "./DatosGenerales.vue?vue&type=template&id=cf8b5e0c"
import script from "./DatosGenerales.vue?vue&type=script&lang=js"
export * from "./DatosGenerales.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__